module.exports = __webpack_public_path__ + "img/Group 1281.3470a95b.svg";